/** Snooze presets as ISO times, from the person's own clock. */
export function snoozePresets(now = new Date()): Array<{ label: string; at: string }> {
  const hour = new Date(now.getTime() + 60 * 60_000)
  const tomorrow = new Date(now)
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(9, 0, 0, 0)
  const nextWeek = new Date(now)
  nextWeek.setDate(nextWeek.getDate() + ((8 - nextWeek.getDay()) % 7 || 7))
  nextWeek.setHours(9, 0, 0, 0)
  return [
    { label: 'In an hour', at: hour.toISOString() },
    { label: 'Tomorrow, 9:00', at: tomorrow.toISOString() },
    { label: 'Next Monday, 9:00', at: nextWeek.toISOString() },
  ]
}
